/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "./utils";
import { Flex, Icon } from "@aws-amplify/ui-react";
export default function AppLogo(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: {
        Vector38503218: {},
        Vector38503219: {},
        Vector38503220: {},
        Vector38503221: {},
        Vector38503222: {},
        Vector38503223: {},
        Vector38503224: {},
        Vector38503225: {},
        Vector38503226: {},
        Vector38503227: {},
        Vector38503228: {},
        Vector38503229: {},
        Vector38503230: {},
        Vector38503231: {},
        Vector38503232: {},
        Vector38503233: {},
        Vector38503234: {},
        Vector38503235: {},
        Vector38503236: {},
        Vector38503237: {},
        Vector38503238: {},
        Vector38503239: {},
        Vector38503240: {},
        Vector38503241: {},
        Vector38503242: {},
        Vector38503243: {},
        Vector38503244: {},
        Vector38503245: {},
        Vector38503246: {},
        Vector38503247: {},
        Vector38503248: {},
        Vector38503249: {},
        Vector38503250: {},
        Vector38503251: {},
        Vector38503252: {},
        Vector38503253: {},
        Vector38503254: {},
        Vector38503255: {},
        Vector38503256: {},
        Vector38503257: {},
        Vector38503258: {},
        Vector38503259: {},
        Vector38503260: {},
        Vector38503261: {},
        Vector38503262: {},
        Ikimy_logo: {},
        AppLogo: {},
      },
      variantValues: { darkMode: "False" },
    },
    {
      overrides: {
        Vector38503218: {},
        Vector38503219: {},
        Vector38503220: {},
        Vector38503221: {},
        Vector38503222: {},
        Vector38503223: {},
        Vector38503224: {},
        Vector38503225: {},
        Vector38503226: {},
        Vector38503227: {},
        Vector38503228: {},
        Vector38503229: {},
        Vector38503230: {},
        Vector38503231: {},
        Vector38503232: { top: "89.89%" },
        Vector38503233: { top: "89.89%" },
        Vector38503234: {},
        Vector38503235: {},
        Vector38503236: {},
        Vector38503237: {
          paths: [
            {
              d: "M9.73771 0L0 0L0 58.9283L9.73771 58.9283L9.73771 0Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
            },
          ],
        },
        Vector38503238: {},
        Vector38503239: {},
        Vector38503240: {},
        Vector38503241: {},
        Vector38503242: {},
        Vector38503243: {},
        Vector38503244: {},
        Vector38503245: {},
        Vector38503246: {},
        Vector38503247: {},
        Vector38503248: {},
        Vector38503249: {},
        Vector38503250: {},
        Vector38503251: {},
        Vector38503252: {},
        Vector38503253: {
          paths: [
            {
              d: "M43.5684 0C40.8356 0 38.2912 0.659646 35.9981 1.97894C34.1134 3.07835 32.48 4.39764 31.1293 5.96822C28.6163 2.01035 24.6584 0 19.3498 0C16.4913 0 14.0097 0.628234 11.968 1.8847C10.6801 2.66999 9.54924 3.58093 8.60688 4.55469L8.60688 0.785292L0 0.785292L0 39.1704L8.60688 39.1704L8.60688 13.2243C9.42359 11.6851 10.5858 10.4287 12.0308 9.51774C13.5386 8.54398 15.2662 8.0728 17.1509 8.0728C19.6639 8.0728 21.6428 8.88951 23.1506 10.5543C24.6584 12.2191 25.4437 14.5122 25.4437 17.3707L25.4437 39.2018L33.9877 39.2018L33.9877 15.2975L33.9877 15.2347C33.9249 14.5122 33.8307 13.8526 33.705 13.2557C34.616 11.8422 35.8725 10.6171 37.4431 9.64339C39.0765 8.6068 40.8041 8.0728 42.5004 8.0728C45.1076 8.0728 47.118 8.88951 48.6257 10.5229C50.1335 12.1877 50.8874 14.4808 50.8874 17.3392L50.8874 39.1704L59.4314 39.1704L59.4314 16.1142C59.4314 11.2454 57.9551 7.31892 55.0652 4.39764C52.1125 1.47635 48.2802 0 43.5684 0Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
            },
          ],
        },
        Vector38503254: {
          paths: [
            {
              d: "M30.0612 0L19.5697 26.1345L9.14088 0L0 0L15.172 36.3119L8.35559 51.8293L17.5593 51.8293L39.2649 0L30.0612 0Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
            },
          ],
        },
        Vector38503255: {
          paths: [
            {
              d: "M8.70111 18.2188L8.70111 0L8.22993 0C7.66452 0.157058 7.06769 0.251295 6.50228 0.34553C5.87404 0.408354 5.2458 0.471175 4.61756 0.471175C3.36108 0.471175 2.13601 0.314119 0.942359 0.0314136L0 0.0314136L0 18.2502C0 29.3071 9.01523 38.3223 20.0722 38.3223L20.0722 29.6212C13.7899 29.5898 8.70111 24.4697 8.70111 18.2188Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
            },
          ],
        },
        Vector38503256: {
          paths: [
            {
              d: "M33.9249 0.691056C33.2967 0.753879 32.6684 0.816703 32.0402 0.816703C30.5638 0.816703 29.1189 0.596821 27.7682 0.219881L27.7682 28.9616C27.7682 29.6212 27.3598 29.9667 27.0143 30.1238C26.6688 30.2809 26.1662 30.3751 25.6636 29.9353L8.1357 12.4704L20.6062 0L10.0518 0L0 10.0832L0 16.7738L19.7895 36.3433L19.8524 36.3747C21.7371 38.071 24.093 38.9505 26.4803 38.9505C27.8624 38.9505 29.2445 38.6678 30.5953 38.071C34.239 36.4376 36.5007 32.9509 36.5007 28.9616L36.5007 0.125645C36.2808 0.188468 36.0609 0.251293 35.8411 0.314117C35.2128 0.471175 34.5532 0.596821 33.9249 0.691056Z",
              fill: "rgba(255,255,255,1)",
              fillRule: "nonzero",
            },
          ],
        },
        Vector38503257: {},
        Vector38503258: {},
        Vector38503259: {},
        Vector38503260: {},
        Vector38503261: {},
        Vector38503262: {},
        Ikimy_logo: {},
        AppLogo: {},
      },
      variantValues: { darkMode: "true" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="5.4473161697387695px"
      direction="column"
      width="unset"
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="8.715705871582031px 8.715705871582031px 8.715705871582031px 8.715705871582031px"
      display="flex"
      {...getOverrideProps(overrides, "AppLogo")}
      {...rest}
    >
      <Flex
        padding="0px 0px 0px 0px"
        width="177.04px"
        height="79.89px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        shrink="0"
        position="relative"
        {...getOverrideProps(overrides, "Ikimy_logo")}
      >
        <Icon
          width="1.44px"
          height="0.94px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 1.444947600364685,
            height: 0.9423505663871765,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="14.48%"
          bottom="84.34%"
          left="36.04%"
          right="63.15%"
          {...getOverrideProps(overrides, "Vector38503218")}
        ></Icon>
        <Icon
          width="0.53px"
          height="0.6px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.5340024828910828,
            height: 0.5968212485313416,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="13.3%"
          bottom="85.95%"
          left="35.52%"
          right="64.18%"
          {...getOverrideProps(overrides, "Vector38503219")}
        ></Icon>
        <Icon
          width="1.07px"
          height="0.41px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 1.0680049657821655,
            height: 0.4083528220653534,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="15.62%"
          bottom="83.87%"
          left="39.32%"
          right="60.08%"
          {...getOverrideProps(overrides, "Vector38503220")}
        ></Icon>
        <Icon
          width="0.13px"
          height="0.79px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.1256471425294876,
            height: 0.7852920889854431,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="6.5%"
          bottom="92.52%"
          left="7.17%"
          right="92.76%"
          {...getOverrideProps(overrides, "Vector38503221")}
        ></Icon>
        <Icon
          width="0.75px"
          height="0.44px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.7538852691650391,
            height: 0.4397640824317932,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="15.11%"
          bottom="84.34%"
          left="39.92%"
          right="59.65%"
          {...getOverrideProps(overrides, "Vector38503222")}
        ></Icon>
        <Icon
          width="0.6px"
          height="0.66px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.5968278050422668,
            height: 0.6596449017524719,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="12.91%"
          bottom="86.27%"
          left="6.17%"
          right="93.49%"
          {...getOverrideProps(overrides, "Vector38503223")}
        ></Icon>
        <Icon
          width="0.47px"
          height="0.57px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.4711795151233673,
            height: 0.5654102563858032,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="2.84%"
          bottom="96.45%"
          left="35.52%"
          right="64.21%"
          {...getOverrideProps(overrides, "Vector38503224")}
        ></Icon>
        <Icon
          width="0.57px"
          height="0.09px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.5654157400131226,
            height: 0.09423481673002243,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="15.97%"
          bottom="83.91%"
          left="3.97%"
          right="95.71%"
          {...getOverrideProps(overrides, "Vector38503225")}
        ></Icon>
        <Icon
          width="0.31px"
          height="0.41px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.31411975622177124,
            height: 0.4083516597747803,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="12.79%"
          bottom="86.7%"
          left="0.67%"
          right="99.15%"
          {...getOverrideProps(overrides, "Vector38503226")}
        ></Icon>
        <Icon
          width="0.79px"
          height="0.19px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.7852992415428162,
            height: 0.18847009539604187,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0.17%"
          bottom="99.6%"
          left="4.22%"
          right="95.33%"
          {...getOverrideProps(overrides, "Vector38503227")}
        ></Icon>
        <Icon
          width="0.06px"
          height="0.79px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.06282297521829605,
            height: 0.7852920889854431,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="7.36%"
          bottom="91.65%"
          left="42%"
          right="57.97%"
          {...getOverrideProps(overrides, "Vector38503228")}
        ></Icon>
        <Icon
          width="4.3px"
          height="4.37px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 4.303438186645508,
            height: 4.366222381591797,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="89.93%"
          bottom="4.6%"
          left="26.49%"
          right="71.08%"
          {...getOverrideProps(overrides, "Vector38503229")}
        ></Icon>
        <Icon
          width="0.66px"
          height="0.41px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.6596514582633972,
            height: 0.4083518981933594,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0.99%"
          bottom="98.49%"
          left="5.29%"
          right="94.34%"
          {...getOverrideProps(overrides, "Vector38503230")}
        ></Icon>
        <Icon
          width="0.13px"
          height="1.26px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.1256459504365921,
            height: 1.256467342376709,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="8.39%"
          bottom="90.04%"
          left="34.78%"
          right="65.15%"
          {...getOverrideProps(overrides, "Vector38503231")}
        ></Icon>
        <Icon
          width="4.11px"
          height="4.4px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 4.114969730377197,
            height: 4.3976359367370605,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="89.9%"
          bottom="4.6%"
          left="46.42%"
          right="51.26%"
          {...getOverrideProps(overrides, "Vector38503232")}
        ></Icon>
        <Icon
          width="4.11px"
          height="4.4px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 4.114969730377197,
            height: 4.3976359367370605,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="89.9%"
          bottom="4.6%"
          left="69.38%"
          right="28.3%"
          {...getOverrideProps(overrides, "Vector38503233")}
        ></Icon>
        <Icon
          width="4.3px"
          height="4.37px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 4.303433418273926,
            height: 4.366222381591797,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="89.93%"
          bottom="4.6%"
          left="73.74%"
          right="23.83%"
          {...getOverrideProps(overrides, "Vector38503234")}
        ></Icon>
        <Icon
          width="4.3px"
          height="4.37px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 4.30344295501709,
            height: 4.366222381591797,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="89.93%"
          bottom="4.6%"
          left="59%"
          right="38.57%"
          {...getOverrideProps(overrides, "Vector38503235")}
        ></Icon>
        <Icon
          width="0.75px"
          height="0.66px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.7538864612579346,
            height: 0.6596453785896301,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="1.62%"
          bottom="97.55%"
          left="5.75%"
          right="93.83%"
          {...getOverrideProps(overrides, "Vector38503236")}
        ></Icon>
        <Icon
          width="9.74px"
          height="58.93px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 9.737709045410156,
            height: 58.928321838378906,
          }}
          paths={[
            {
              d: "M9.73771 0L0 0L0 58.9283L9.73771 58.9283L9.73771 0Z",
              fill: "rgba(34,66,114,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0.99%"
          bottom="25.24%"
          left="13.38%"
          right="81.12%"
          {...getOverrideProps(overrides, "Vector38503237")}
        ></Icon>
        <Icon
          width="5.31px"
          height="9.27px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 5.30862283706665,
            height: 9.266447067260742,
          }}
          paths={[
            {
              d: "M0 9.26645L5.30862 9.26645L5.30862 8.0728L1.28789 8.0728L1.28789 4.99446L4.86885 4.99446L4.86885 3.7694L1.28789 3.7694L1.28789 1.22505L5.30862 1.22505L5.30862 0L0 0L0 9.26645Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="85.1%"
          bottom="3.3%"
          left="16.18%"
          right="80.82%"
          {...getOverrideProps(overrides, "Vector38503238")}
        ></Icon>
        <Icon
          width="5.97px"
          height="6.57px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 5.968271255493164,
            height: 6.565044403076172,
          }}
          paths={[
            {
              d: "M3.32967 0C2.8899 0 2.48154 0.0942379 2.1046 0.282708C1.72766 0.471178 1.44495 0.722472 1.22507 1.068L1.22507 0.12565L0 0.12565L0 6.56504L1.22507 6.56504L1.22507 2.23023C1.41354 1.91611 1.66483 1.66482 1.97895 1.47635C2.32448 1.28788 2.67002 1.19364 3.04696 1.19364C3.54955 1.19364 3.98932 1.35071 4.27203 1.69623C4.58615 2.04176 4.74321 2.48153 4.74321 3.04694L4.74321 6.56504L5.96827 6.56504L5.96827 2.88988C5.96827 2.01035 5.71698 1.31929 5.2458 0.785292C4.80603 0.251293 4.14638 0 3.32967 0Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.48%"
          bottom="3.3%"
          left="20.03%"
          right="76.6%"
          {...getOverrideProps(overrides, "Vector38503239")}
        ></Icon>
        <Icon
          width="2.32px"
          height="9.08px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 2.324488401412964,
            height: 9.077974319458008,
          }}
          paths={[
            {
              d: "M1.09942 6.78492C1.09942 7.57021 0.816714 7.94716 0.282711 7.94716C0.188475 7.94716 0.125649 7.94716 0.0942369 7.94716L0 9.04657C0.15706 9.07798 0.282712 9.07797 0.376947 9.07797C1.00519 9.07797 1.47636 8.8895 1.8219 8.51256C2.16743 8.13562 2.32449 7.60163 2.32449 6.87916L2.32449 0L1.09942 0L1.09942 6.78492Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.64%"
          bottom="0%"
          left="23.76%"
          right="74.93%"
          {...getOverrideProps(overrides, "Vector38503240")}
        ></Icon>
        <Icon
          width="1.63px"
          height="1.66px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 1.6334213018417358,
            height: 1.6648154258728027,
          }}
          paths={[
            {
              d: "M0.816713 0C0.596829 0 0.408357 0.0942312 0.251297 0.25129C0.0942369 0.408348 0 0.596819 0 0.816701C0 1.03658 0.0942369 1.22506 0.251297 1.41353C0.408357 1.57058 0.596829 1.66482 0.816713 1.66482C1.0366 1.66482 1.22507 1.57058 1.38213 1.41353C1.53919 1.25647 1.63342 1.068 1.63342 0.848114C1.63342 0.628233 1.53919 0.439762 1.38213 0.282703C1.25648 0.0628215 1.0366 0 0.816713 0Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="85.02%"
          bottom="12.9%"
          left="24.25%"
          right="74.82%"
          {...getOverrideProps(overrides, "Vector38503241")}
        ></Icon>
        <Icon
          width="6.66px"
          height="6.69px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 6.659335613250732,
            height: 6.690689563751221,
          }}
          paths={[
            {
              d: "M5.02591 0.439766C4.52332 0.157061 3.95791 0 3.32967 0C2.38731 0 1.60201 0.314119 0.973773 0.973764C0.345534 1.63341 0 2.4187 0 3.36105C0 3.98929 0.157058 4.5547 0.439766 5.05728C0.722473 5.55987 1.13083 5.96822 1.63342 6.25093C2.13601 6.53363 2.70143 6.69069 3.32967 6.69069C4.27203 6.69069 5.05733 6.37658 5.68557 5.71693C6.31381 5.0887 6.65934 4.27199 6.65934 3.32964C6.65934 2.70141 6.50228 2.136 6.21957 1.63341C5.93686 1.13082 5.55992 0.722472 5.02591 0.439766ZM4.86885 4.90022C4.4605 5.30858 3.95791 5.52846 3.36108 5.52846C2.76425 5.52846 2.23025 5.30858 1.82189 4.90022C1.41354 4.49187 1.19366 3.95788 1.19366 3.36105C1.19366 2.73282 1.41354 2.19882 1.82189 1.79047C2.23025 1.38212 2.73284 1.16224 3.36108 1.16224C3.95791 1.16224 4.4605 1.38212 4.86885 1.79047C5.27721 2.19882 5.49709 2.73282 5.49709 3.36105C5.49709 3.95788 5.27721 4.49187 4.86885 4.90022Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.48%"
          bottom="3.15%"
          left="25.82%"
          right="70.42%"
          {...getOverrideProps(overrides, "Vector38503242")}
        ></Icon>
        <Icon
          width="6.47px"
          height="8.8px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 6.470866680145264,
            height: 8.795271873474121,
          }}
          paths={[
            {
              d: "M3.23543 4.80599L1.31931 0L0 0L2.60719 6.21951L1.47637 8.79527L2.76425 8.79527L6.47087 0L5.15157 0L3.23543 4.80599Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.64%"
          bottom="0.35%"
          left="29.79%"
          right="66.55%"
          {...getOverrideProps(overrides, "Vector38503243")}
        ></Icon>
        <Icon
          width="10.02px"
          height="6.44px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 10.02042007446289,
            height: 6.439394474029541,
          }}
          paths={[
            {
              d: "M7.16193 4.61752L5.49709 0L4.49191 0L2.85849 4.61752L1.28789 0L0 0L2.3559 6.43939L3.29826 6.43939L4.99451 1.82188L6.69075 6.43939L7.66452 6.43939L10.0204 0L8.70112 0L7.16193 4.61752Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.64%"
          bottom="3.3%"
          left="35.38%"
          right="58.96%"
          {...getOverrideProps(overrides, "Vector38503244")}
        ></Icon>
        <Icon
          width="5.97px"
          height="9.27px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 5.968273639678955,
            height: 9.266447067260742,
          }}
          paths={[
            {
              d: "M3.32967 2.7014C2.8899 2.7014 2.48154 2.79564 2.1046 2.98411C1.72766 3.17258 1.44495 3.42387 1.22506 3.73799L1.22506 0L0 0L0 9.26645L1.22506 9.26645L1.22506 4.90022C1.41354 4.5861 1.66483 4.33481 2.01036 4.14634C2.32448 3.95787 2.67002 3.86364 3.04696 3.86364C3.54955 3.86364 3.9579 4.02069 4.27202 4.36622C4.58614 4.71175 4.7432 5.15152 4.7432 5.71693L4.7432 9.23503L5.96827 9.23503L5.96827 5.55987C5.96827 4.68034 5.71698 3.98928 5.2458 3.45529C4.77462 2.9527 4.11496 2.7014 3.32967 2.7014Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="85.1%"
          bottom="3.3%"
          left="41.63%"
          right="55%"
          {...getOverrideProps(overrides, "Vector38503245")}
        ></Icon>
        <Icon
          width="6.53px"
          height="6.72px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 6.533694744110107,
            height: 6.722103118896484,
          }}
          paths={[
            {
              d: "M5.30863 1.068C5.15157 0.753883 4.83744 0.502587 4.42909 0.314117C4.02073 0.125647 3.58096 0 3.1412 0C2.54437 0 2.01037 0.157061 1.53919 0.439766C1.06801 0.722472 0.691069 1.13082 0.408361 1.66482C0.125654 2.16741 0 2.73282 0 3.36105C0 3.98929 0.125654 4.5547 0.408361 5.05728C0.691069 5.55987 1.06801 5.96822 1.53919 6.28234C2.01037 6.56504 2.54437 6.7221 3.1412 6.7221C3.58096 6.7221 4.02073 6.62787 4.42909 6.40799C4.83744 6.21952 5.12016 5.93681 5.30863 5.6541L5.30863 6.59645L6.53369 6.59645L6.53369 0.157058L5.30863 0.157058L5.30863 1.068ZM5.30863 4.49187C5.15157 4.80599 4.86886 5.05728 4.52333 5.27716C4.1778 5.46563 3.80085 5.59128 3.3925 5.59128C2.76426 5.59128 2.26167 5.3714 1.8219 4.96305C1.41354 4.5547 1.19366 4.0207 1.19366 3.39246C1.19366 2.76423 1.41354 2.23023 1.8219 1.82188C2.23026 1.41353 2.76426 1.19364 3.3925 1.19364C3.80085 1.19364 4.1778 1.28788 4.52333 1.50776C4.86886 1.69623 5.15157 1.97894 5.30863 2.29305L5.30863 4.49187Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.48%"
          bottom="3.11%"
          left="45.74%"
          right="50.57%"
          {...getOverrideProps(overrides, "Vector38503246")}
        ></Icon>
        <Icon
          width="4.27px"
          height="8.26px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 4.272029399871826,
            height: 8.261274337768555,
          }}
          paths={[
            {
              d: "M3.73802 7.13045C3.36108 7.13045 3.07837 7.00481 2.82708 6.78493C2.57578 6.53363 2.48154 6.21951 2.48154 5.81116L2.48154 2.92129L4.2092 2.92129L4.2092 1.75906L2.48154 1.75906L2.48154 0L1.25648 0L1.25648 1.75906L0 1.75906L0 2.92129L1.25648 2.92129L1.25648 5.87398C1.25648 6.62786 1.47636 7.22469 1.88472 7.63304C2.32449 8.04139 2.8899 8.26127 3.58096 8.26127C3.83226 8.26127 4.08356 8.22987 4.27203 8.13563L4.2092 7.06763C4.08355 7.13045 3.92649 7.13045 3.73802 7.13045Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="86.43%"
          bottom="3.22%"
          left="50.02%"
          right="47.57%"
          {...getOverrideProps(overrides, "Vector38503247")}
        ></Icon>
        <Icon
          width="6.47px"
          height="8.8px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 6.470866680145264,
            height: 8.795271873474121,
          }}
          paths={[
            {
              d: "M3.20401 4.80599L1.28789 0L0 0L2.60719 6.21951L1.47636 8.79527L2.76425 8.79527L6.47087 0L5.15156 0L3.20401 4.80599Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.64%"
          bottom="0.35%"
          left="54.49%"
          right="41.86%"
          {...getOverrideProps(overrides, "Vector38503248")}
        ></Icon>
        <Icon
          width="6.66px"
          height="6.69px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 6.659339904785156,
            height: 6.690689563751221,
          }}
          paths={[
            {
              d: "M5.02591 0.439766C4.52332 0.157061 3.95791 0 3.32967 0C2.38731 0 1.60201 0.314119 0.973773 0.973764C0.345534 1.63341 0 2.4187 0 3.36105C0 3.98929 0.157067 4.5547 0.439775 5.05728C0.722483 5.55987 1.13083 5.96822 1.63343 6.25093C2.13602 6.53363 2.70143 6.69069 3.32967 6.69069C4.27203 6.69069 5.05733 6.37658 5.68557 5.71693C6.31381 5.0887 6.65934 4.27199 6.65934 3.32964C6.65934 2.70141 6.50228 2.136 6.21957 1.63341C5.93687 1.13082 5.52851 0.722472 5.02591 0.439766ZM4.83745 4.90022C4.42909 5.30858 3.9265 5.52846 3.32967 5.52846C2.73284 5.52846 2.19884 5.30858 1.79049 4.90022C1.38213 4.49187 1.16225 3.95788 1.16225 3.36105C1.16225 2.73282 1.38213 2.19882 1.79049 1.79047C2.19884 1.38212 2.70143 1.16224 3.32967 1.16224C3.9265 1.16224 4.42909 1.38212 4.83745 1.79047C5.24581 2.19882 5.46569 2.73282 5.46569 3.36105C5.46569 3.95788 5.27722 4.49187 4.83745 4.90022Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.48%"
          bottom="3.15%"
          left="58.34%"
          right="37.9%"
          {...getOverrideProps(overrides, "Vector38503249")}
        ></Icon>
        <Icon
          width="5.97px"
          height="6.6px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 5.968273639678955,
            height: 6.5964531898498535,
          }}
          paths={[
            {
              d: "M4.74321 4.33481C4.55474 4.64893 4.30344 4.90022 3.98932 5.08869C3.6752 5.27716 3.29826 5.37139 2.92132 5.37139C2.41873 5.37139 2.01037 5.21434 1.69625 4.86881C1.38213 4.52328 1.22507 4.08352 1.22507 3.51811L1.22507 0L0 0L0 3.70658C0 4.58611 0.251301 5.27716 0.722481 5.81116C1.19366 6.34516 1.85331 6.59645 2.63861 6.59645C3.07838 6.59645 3.48673 6.50221 3.86368 6.31375C4.24062 6.12527 4.52332 5.87398 4.74321 5.52845L4.74321 6.4708L5.96827 6.4708L5.96827 0.0314088L4.74321 0.0314088L4.74321 4.33481Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.64%"
          bottom="3.11%"
          left="62.86%"
          right="33.77%"
          {...getOverrideProps(overrides, "Vector38503250")}
        ></Icon>
        <Icon
          width="6.53px"
          height="9.39px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 6.533694744110107,
            height: 9.392096519470215,
          }}
          paths={[
            {
              d: "M5.30863 3.73799C5.15157 3.42388 4.83744 3.17258 4.42909 2.98411C4.02073 2.79564 3.58096 2.66999 3.1412 2.66999C2.54437 2.66999 2.01037 2.82705 1.53919 3.10976C1.06801 3.39246 0.691069 3.80081 0.408361 4.33481C0.125654 4.8374 0 5.40281 0 6.03105C0 6.65928 0.125654 7.22469 0.408361 7.72728C0.691069 8.22986 1.06801 8.63821 1.53919 8.95233C2.01037 9.23503 2.54437 9.3921 3.1412 9.3921C3.58096 9.3921 4.02073 9.29786 4.42909 9.07798C4.83744 8.88951 5.12016 8.6068 5.30863 8.3241L5.30863 9.26645L6.53369 9.26645L6.53369 0L5.30863 0L5.30863 3.73799ZM5.30863 7.16186C5.15157 7.47598 4.86886 7.72727 4.52333 7.94716C4.1778 8.13563 3.80085 8.26127 3.3925 8.26127C2.76426 8.26127 2.26167 8.04139 1.8219 7.63304C1.41354 7.22469 1.19366 6.69069 1.19366 6.06246C1.19366 5.43422 1.41354 4.90022 1.8219 4.49187C2.23026 4.08352 2.76426 3.86364 3.3925 3.86364C3.80085 3.86364 4.1778 3.95787 4.52333 4.17775C4.86886 4.36622 5.15157 4.64893 5.30863 4.96305L5.30863 7.16186Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="85.14%"
          bottom="3.11%"
          left="68.72%"
          right="27.59%"
          {...getOverrideProps(overrides, "Vector38503251")}
        ></Icon>
        <Icon
          width="6.66px"
          height="6.69px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 6.659339904785156,
            height: 6.690689563751221,
          }}
          paths={[
            {
              d: "M5.02591 0.439766C4.52332 0.157061 3.95791 0 3.32967 0C2.38731 0 1.60201 0.314119 0.973773 0.973764C0.345534 1.63341 0 2.4187 0 3.36105C0 3.98929 0.157058 4.5547 0.439766 5.05728C0.722473 5.55987 1.13083 5.96822 1.63343 6.25093C2.13602 6.53363 2.70143 6.69069 3.32967 6.69069C4.27203 6.69069 5.05733 6.37658 5.68557 5.71693C6.31381 5.0887 6.65934 4.27199 6.65934 3.32964C6.65934 2.70141 6.50228 2.136 6.21957 1.63341C5.93687 1.13082 5.52851 0.722472 5.02591 0.439766ZM4.83744 4.90022C4.42908 5.30858 3.9265 5.52846 3.32967 5.52846C2.73284 5.52846 2.19884 5.30858 1.79049 4.90022C1.38213 4.49187 1.16225 3.95788 1.16225 3.36105C1.16225 2.73282 1.38213 2.19882 1.79049 1.79047C2.19884 1.38212 2.70143 1.16224 3.32967 1.16224C3.9265 1.16224 4.42908 1.38212 4.83744 1.79047C5.2458 2.19882 5.46568 2.73282 5.46568 3.36105C5.46568 3.95788 5.27721 4.49187 4.83744 4.90022Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="88.48%"
          bottom="3.15%"
          left="73.08%"
          right="23.15%"
          {...getOverrideProps(overrides, "Vector38503252")}
        ></Icon>
        <Icon
          width="59.43px"
          height="39.2px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 59.43144226074219,
            height: 39.2017822265625,
          }}
          paths={[
            {
              d: "M43.5684 0C40.8356 0 38.2912 0.659646 35.9981 1.97894C34.1134 3.07835 32.48 4.39764 31.1293 5.96822C28.6163 2.01035 24.6584 0 19.3498 0C16.4913 0 14.0097 0.628234 11.968 1.8847C10.6801 2.66999 9.54924 3.58093 8.60688 4.55469L8.60688 0.785292L0 0.785292L0 39.1704L8.60688 39.1704L8.60688 13.2243C9.42359 11.6851 10.5858 10.4287 12.0308 9.51774C13.5386 8.54398 15.2662 8.0728 17.1509 8.0728C19.6639 8.0728 21.6428 8.88951 23.1506 10.5543C24.6584 12.2191 25.4437 14.5122 25.4437 17.3707L25.4437 39.2018L33.9877 39.2018L33.9877 15.2975L33.9877 15.2347C33.9249 14.5122 33.8307 13.8526 33.705 13.2557C34.616 11.8422 35.8725 10.6171 37.4431 9.64339C39.0765 8.6068 40.8041 8.0728 42.5004 8.0728C45.1076 8.0728 47.118 8.88951 48.6257 10.5229C50.1335 12.1877 50.8874 14.4808 50.8874 17.3392L50.8874 39.1704L59.4314 39.1704L59.4314 16.1142C59.4314 11.2454 57.9551 7.31892 55.0652 4.39764C52.1125 1.47635 48.2802 0 43.5684 0Z",
              fill: "rgba(34,66,114,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="25.02%"
          bottom="25.91%"
          left="44.59%"
          right="21.84%"
          {...getOverrideProps(overrides, "Vector38503253")}
        ></Icon>
        <Icon
          width="39.26px"
          height="51.83px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 39.264949798583984,
            height: 51.82927703857422,
          }}
          paths={[
            {
              d: "M30.0612 0L19.5697 26.1345L9.14088 0L0 0L15.172 36.3119L8.35559 51.8293L17.5593 51.8293L39.2649 0L30.0612 0Z",
              fill: "rgba(34,66,114,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="26%"
          bottom="9.12%"
          left="77.82%"
          right="0%"
          {...getOverrideProps(overrides, "Vector38503254")}
        ></Icon>
        <Icon
          width="20.07px"
          height="38.32px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 20.07224464416504,
            height: 38.3222541809082,
          }}
          paths={[
            {
              d: "M8.70111 18.2188L8.70111 0L8.22993 0C7.66452 0.157058 7.06769 0.251295 6.50228 0.34553C5.87404 0.408354 5.2458 0.471175 4.61756 0.471175C3.36108 0.471175 2.13601 0.314119 0.942359 0.0314136L0 0.0314136L0 18.2502C0 29.3071 9.01523 38.3223 20.0722 38.3223L20.0722 29.6212C13.7899 29.5898 8.70111 24.4697 8.70111 18.2188Z",
              fill: "rgba(34,66,114,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="26.08%"
          bottom="25.95%"
          left="1.03%"
          right="87.63%"
          {...getOverrideProps(overrides, "Vector38503255")}
        ></Icon>
        <Icon
          width="36.5px"
          height="38.95px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 36.50070571899414,
            height: 38.95048904418945,
          }}
          paths={[
            {
              d: "M33.9249 0.691056C33.2967 0.753879 32.6684 0.816703 32.0402 0.816703C30.5638 0.816703 29.1189 0.596821 27.7682 0.219881L27.7682 28.9616C27.7682 29.6212 27.3598 29.9667 27.0143 30.1238C26.6688 30.2809 26.1662 30.3751 25.6636 29.9353L8.1357 12.4704L20.6062 0L10.0518 0L0 10.0832L0 16.7738L19.7895 36.3433L19.8524 36.3747C21.7371 38.071 24.093 38.9505 26.4803 38.9505C27.8624 38.9505 29.2445 38.6678 30.5953 38.071C34.239 36.4376 36.5007 32.9509 36.5007 28.9616L36.5007 0.125645C36.2808 0.188468 36.0609 0.251293 35.8411 0.314117C35.2128 0.471175 34.5532 0.596821 33.9249 0.691056Z",
              fill: "rgba(34,66,114,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="25.92%"
          bottom="25.32%"
          left="20.3%"
          right="59.08%"
          {...getOverrideProps(overrides, "Vector38503256")}
        ></Icon>
        <Icon
          width="12.88px"
          height="12.92px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 12.87890625,
            height: 12.918996810913086,
          }}
          paths={[
            {
              d: "M3.39249 12.1651C3.6752 12.3222 3.95791 12.4478 4.24062 12.5421C4.58615 12.6677 4.96309 12.7619 5.34003 12.8248C5.49709 12.8562 5.68557 12.8562 5.87404 12.8876C6.06251 12.919 6.21957 12.919 6.40804 12.919C6.47087 12.919 6.53369 12.919 6.62792 12.919C6.75357 12.919 6.91063 12.919 7.03628 12.8876C7.0991 12.8876 7.19334 12.8876 7.25616 12.8562C7.38181 12.8562 7.47605 12.8248 7.6017 12.7933C7.66452 12.7933 7.72734 12.7619 7.79017 12.7619C7.8844 12.7305 7.97864 12.7305 8.07288 12.6991C8.22994 12.6677 8.41841 12.6049 8.57547 12.5421C8.76394 12.4792 8.95241 12.385 9.14088 12.2908C9.32935 12.1965 9.51783 12.1023 9.67489 12.0081C9.73771 11.9766 9.76912 11.9452 9.83195 11.9138C9.95759 11.8196 10.0832 11.7254 10.2089 11.6311C10.2403 11.5997 10.2717 11.5683 10.3031 11.5683C10.3345 11.5369 10.3974 11.5055 10.4288 11.4741C10.5858 11.3484 10.7743 11.1914 10.9314 11.0343C11.1512 10.8144 11.3397 10.5945 11.5282 10.3747L11.5596 10.3432C11.7795 10.0605 11.968 9.77783 12.125 9.49512C12.2821 9.21242 12.4077 8.8983 12.5334 8.58419C12.659 8.27007 12.7218 7.92454 12.7847 7.61042C12.8161 7.45336 12.8475 7.26489 12.8475 7.10784C12.8475 6.91937 12.8789 6.76231 12.8789 6.57384C12.8789 6.41678 12.8789 6.25972 12.8475 6.10266C12.8161 5.9456 12.8161 5.78854 12.7847 5.63149C12.7847 5.53725 12.7533 5.44302 12.7218 5.31737C12.6904 5.1289 12.6276 4.90902 12.5648 4.72055C12.502 4.53208 12.4391 4.34361 12.3449 4.15514C12.2821 3.99808 12.1878 3.84102 12.125 3.68396C12.0308 3.5269 11.968 3.40126 11.8737 3.2442C11.7795 3.08714 11.6538 2.93008 11.5596 2.77302C11.4968 2.7102 11.434 2.61597 11.3711 2.55314C11.2455 2.39608 11.0884 2.23902 10.9314 2.08197C10.6801 1.70503 10.4288 1.51656 10.1775 1.29667C10.1461 1.26526 10.1147 1.23385 10.0832 1.23385C10.0518 1.23385 10.0518 1.20244 10.0204 1.20244C9.92618 1.13962 9.86336 1.07679 9.76912 1.04538C9.64347 0.951146 9.51783 0.888322 9.36077 0.794087C9.17229 0.699852 8.98382 0.605617 8.79535 0.511382C8.60688 0.417147 8.41841 0.354324 8.22994 0.2915C8.04146 0.228677 7.85299 0.165854 7.63311 0.134442C7.57028 0.134442 7.50746 0.10303 7.44464 0.10303C7.41322 0.10303 7.38181 0.10303 7.3504 0.0716186C7.19334 0.040207 7.03628 0.040207 6.87922 0.00879527C6.72216 -0.0226164 6.59651 0.040207 6.40804 0.040207C5.7798 0.040207 5.21439 0.134442 4.64897 0.2915C4.30344 0.385735 3.98932 0.511382 3.6752 0.668441C3.51814 0.762676 3.36108 0.825499 3.20402 0.919734C2.8899 1.1082 2.60719 1.32809 2.29307 1.57938C2.16743 1.70503 2.04178 1.83067 1.88472 1.95632C1.85331 2.01914 1.79048 2.08197 1.72766 2.14479C1.69625 2.20761 1.63342 2.23902 1.5706 2.30185C1.44495 2.45891 1.3193 2.61597 1.19365 2.74161C1.06801 2.89867 0.973771 3.05573 0.879535 3.21279C0.848123 3.27561 0.816711 3.33843 0.785299 3.40126C0.753887 3.43267 0.753887 3.46408 0.722475 3.49549C0.628239 3.68396 0.534003 3.87243 0.471179 4.0609C0.439768 4.15514 0.408356 4.24937 0.345532 4.34361C0.219884 4.68914 0.125648 5.03466 0.0628239 5.38019C0 5.72572 0 6.10266 0 6.44819C0 6.82513 0.031412 7.17066 0.0942359 7.51619C0.125648 7.73607 0.15706 7.92454 0.219884 8.11301C0.251296 8.30148 0.31412 8.45854 0.376944 8.64701C0.47118 8.8983 0.565415 9.11818 0.691063 9.33807C0.722475 9.36948 0.722475 9.4323 0.753887 9.46371C0.753887 9.49512 0.785299 9.49512 0.785299 9.52654C0.879535 9.71501 1.00518 9.90348 1.13083 10.0605C1.16224 10.0919 1.19365 10.1548 1.22507 10.1862C1.25648 10.2804 1.28789 10.3432 1.3193 10.4061C1.38213 10.4689 1.44495 10.5631 1.50777 10.6259C1.53919 10.6574 1.5706 10.6888 1.5706 10.6888C1.66483 10.783 1.75907 10.9086 1.85331 11.0029C1.94754 11.0971 2.01037 11.1599 2.1046 11.2228C2.16743 11.2856 2.19884 11.317 2.23025 11.3484C2.26166 11.3798 2.32449 11.4112 2.3559 11.4426C2.45013 11.5369 2.51296 11.5997 2.60719 11.6625C2.85849 11.851 3.10978 12.0081 3.39249 12.1651Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0%"
          bottom="83.83%"
          left="0%"
          right="92.73%"
          {...getOverrideProps(overrides, "Vector38503257")}
        ></Icon>
        <Icon
          width="0.25px"
          height="0.97px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.2512955069541931,
            height: 0.9737623333930969,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="9.41%"
          bottom="89.37%"
          left="7.06%"
          right="92.8%"
          {...getOverrideProps(overrides, "Vector38503258")}
        ></Icon>
        <Icon
          width="0.41px"
          height="0.91px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.40835651755332947,
            height: 0.9109386801719666,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="10.67%"
          bottom="88.19%"
          left="6.85%"
          right="92.92%"
          {...getOverrideProps(overrides, "Vector38503259")}
        ></Icon>
        <Icon
          width="0.03px"
          height="0.47px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.03141268342733383,
            height: 0.47117528319358826,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="7.48%"
          bottom="91.93%"
          left="7.24%"
          right="92.74%"
          {...getOverrideProps(overrides, "Vector38503260")}
        ></Icon>
        <Icon
          width="0.06px"
          height="0.5px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 0.06282416731119156,
            height: 0.5025864243507385,
          }}
          paths={[]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="8.78%"
          bottom="90.59%"
          left="7.2%"
          right="92.76%"
          {...getOverrideProps(overrides, "Vector38503261")}
        ></Icon>
        <Icon
          width="12.88px"
          height="12.94px"
          viewBox={{
            minX: 0,
            minY: 0,
            width: 12.87890625,
            height: 12.941615104675293,
          }}
          paths={[
            {
              d: "M12.8789 6.4394C12.8789 6.28234 12.8789 6.12528 12.8475 5.96822C12.8475 5.87399 12.8161 5.74834 12.8161 5.6541C12.8161 5.59128 12.8161 5.55987 12.7847 5.49705C12.7847 5.46563 12.7847 5.43422 12.7533 5.40281C12.7533 5.33999 12.7218 5.27716 12.7218 5.18293C12.6904 4.99446 12.6276 4.77458 12.5648 4.58611C12.502 4.39764 12.4391 4.20917 12.3449 4.0207C12.2821 3.86364 12.1878 3.70658 12.125 3.54952C12.0308 3.39246 11.968 3.26682 11.8737 3.10976C11.8423 3.04693 11.7795 2.98411 11.7481 2.92129C11.6853 2.82705 11.6224 2.73282 11.5596 2.63858C11.4968 2.57576 11.4654 2.51293 11.4025 2.45011C11.2455 2.26164 11.1198 2.10458 10.9314 1.94752C10.8057 1.82188 10.6487 1.69623 10.523 1.57058C10.3974 1.44494 10.2403 1.3507 10.0832 1.22506C9.98901 1.16223 9.89477 1.09941 9.80054 1.03659C9.7063 0.973762 9.61206 0.910939 9.51783 0.848116C9.48641 0.816704 9.455 0.816704 9.42359 0.785292C9.23512 0.691057 9.04665 0.596822 8.85818 0.502587C8.66971 0.408352 8.48123 0.345529 8.29276 0.282705C8.10429 0.219882 7.91582 0.157058 7.69593 0.125647C7.6017 0.0942351 7.50746 0.094235 7.44464 0.094235L7.41323 0.094235C7.25617 0.0628234 7.09911 0.0628234 6.94205 0.0314117C6.78499 -1.17018e-08 6.62793 0 6.47087 0C6.25098 0 6.0311 -1.17018e-08 5.81121 0.0314117C5.59133 0.0628234 5.40286 0.0942351 5.18297 0.125647C4.77462 0.219882 4.39768 0.314117 4.02073 0.471175C3.83226 0.56541 3.64379 0.628234 3.45532 0.753881C3.17261 0.910939 2.92131 1.068 2.67002 1.25647C2.41872 1.44494 2.16743 1.69623 1.91613 1.94752C1.88472 1.97894 1.85331 2.01035 1.8219 2.04176C1.75907 2.10458 1.66484 2.19882 1.60201 2.29305C1.50778 2.38729 1.44495 2.48152 1.35072 2.60717C1.19366 2.79564 1.0366 3.01552 0.91095 3.2354C0.848126 3.32964 0.816714 3.42387 0.75389 3.51811C0.659654 3.70658 0.565417 3.89505 0.502593 4.08352C0.471181 4.17775 0.439771 4.27199 0.376947 4.36622C0.2513 4.71175 0.157061 5.05728 0.0942369 5.40281C0.0628249 5.59128 0.0314139 5.74834 0.0314139 5.93681C0.0314139 6.12528 0 6.31375 0 6.50222C0 6.94198 0.0314148 7.35033 0.125651 7.75869C0.157063 7.88433 0.188476 8.04139 0.219888 8.16704C0.2513 8.35551 0.314124 8.51257 0.376947 8.70104C0.439771 8.92092 0.534005 9.1408 0.659653 9.32927C0.691065 9.39209 0.722478 9.45492 0.75389 9.54915C0.785302 9.61198 0.816715 9.64339 0.848127 9.70621C0.942363 9.86327 1.0366 10.0203 1.13083 10.1774C1.19366 10.2716 1.28789 10.3973 1.35072 10.4915C1.41354 10.5857 1.50778 10.68 1.60201 10.7742C1.69625 10.8684 1.79048 10.9941 1.88472 11.0883C1.88472 11.0883 1.91613 11.0883 1.91613 11.1197C2.04178 11.2454 2.13602 11.3396 2.26167 11.4339C2.38731 11.5281 2.51296 11.6223 2.63861 11.7166C2.98414 11.9679 3.32967 12.1877 3.70661 12.3762C4.08356 12.5647 4.49191 12.6903 4.90027 12.7846C5.05733 12.816 5.2458 12.8474 5.40286 12.8788C5.74839 12.9416 6.09392 12.9416 6.47087 12.9416C6.59651 12.9416 6.75358 12.9416 6.87922 12.9416C7.00487 12.9416 7.16193 12.9102 7.28758 12.9102C7.57029 12.8788 7.82158 12.816 8.07288 12.7531C8.22994 12.7217 8.41841 12.6589 8.57547 12.5961C8.76394 12.5333 8.95241 12.439 9.14088 12.3448C9.32936 12.2506 9.51783 12.1563 9.67489 12.0621C9.73771 12.0307 9.83195 11.9679 9.89477 11.905C10.0518 11.8108 10.1775 11.7166 10.3345 11.5909C10.4288 11.4967 10.5544 11.4339 10.6487 11.3396C10.7429 11.2454 10.8685 11.1511 10.9628 11.0569C11.0884 10.9313 11.1827 10.837 11.2769 10.7114C11.3711 10.5857 11.4654 10.4601 11.5596 10.3659C11.6538 10.2402 11.7795 10.0832 11.8737 9.92609C11.968 9.80045 12.0308 9.6748 12.0936 9.54915C12.5334 8.76386 12.7847 7.91574 12.8475 7.00481C12.8789 6.75351 12.8789 6.59645 12.8789 6.4394Z",
              fill: "rgba(204,164,59,1)",
              fillRule: "nonzero",
            },
          ]}
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="0.29%"
          bottom="83.51%"
          left="34.76%"
          right="57.97%"
          {...getOverrideProps(overrides, "Vector38503262")}
        ></Icon>
      </Flex>
    </Flex>
  );
}
